import { getField, updateField } from 'vuex-map-fields';


const SET_SHOW_MODAL = 'SET_SHOW_MODAL';


const state = () => ({
    show_bank_rules_modal: false,
    persistent: false,
   
});


const mutations = {
    [SET_SHOW_MODAL]: (state, show) => {
        state.show_bank_rules_modal = show;
    },
    updateField,
};


const getters = {
    show_bank_rules_modal: state => state.show_bank_rules_modal,
    persistent: state => state.persistent,
    getField
}

const openPopup = ({ commit }) => {
    commit(SET_SHOW_MODAL, true);
};

const closePopup = ({ commit }) => {
    commit(SET_SHOW_MODAL, false)
};

const actions = {
    openPopup,
    closePopup,
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}